/**
 * Phase 24.4b Step 6 — Meal Plan tab.
 *
 * Step 3 shipped this as a placeholder; Step 6 swaps it to render the
 * full MealPlanContainer. Tabs primitive in pages/Nutrition.tsx still
 * dispatches by ?tab=plan URL state.
 */
import { MealPlanContainer } from "@/components/meal_plan/MealPlanContainer";

export default function NutritionPlanTab() {
  return <MealPlanContainer />;
}
